
import {of as observableOf, Observable} from 'rxjs';
import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import { omitBy, isNil } from 'lodash-es';
import { LoginService } from '../service/login.service';

@Injectable({providedIn: 'root'})
export class LoginAppsGuardService {

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

    const queryParams = route.queryParams;
    const { app } = queryParams;
    //
    const appMapping = {sfna: {redirectTo: 'sfna'}, cero: {redirectTo: 'cero'}};
    LoginService.handleRoSsoPopupRedirectUrl(window.location.href);
    if (app && appMapping[app]) {
      // Redirect without rendering view
      // Removing "app" from query params
      const newQp = omitBy({...queryParams, app: undefined}, isNil);
      this.router.navigate([`./${appMapping[app].redirectTo}`], {queryParams: newQp});
      return observableOf(false);
    }
    else {
      // Rendering view
      return observableOf(true);
    }
  }

}

export const LoginAppsGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  return inject(LoginAppsGuardService).canActivate(route);
}
